<ion-content *ngIf="paymentSuccessful">
  <ion-grid class="content">
    <ion-row>
      <ion-col class="ion-justify-content-center">
        <h1>Payment Successful!</h1>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="success-icon ion-justify-content-center">
        <ion-icon src="/assets/icon/rebrand/Done-Icon.svg"></ion-icon>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="infor-text">
        <p>Download a copy of your receipt below.</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button
          shape="round"
          expand="block"
          class="button-red button"
          (click)="getCustomerReceipt()"
          >Download Receipt</ion-button
        >
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button
          shape="round"
          expand="block"
          class="button-blue button"
          (click)="dismissPaymentSuccess()"
          >Return to Payment Portal</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-content *ngIf="!paymentSuccessful">
  <ion-grid class="content">
    <ion-row>
      <ion-col class="ion-justify-content-center">
        <h1>Payment Failed</h1>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="failed-icon ion-justify-content-center">
        <ion-icon name="close-circle"></ion-icon>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="info-text">
        <p>
          Payment could not be processed at this time. <br />
          Please try payment again.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button
          shape="round"
          expand="block"
          class="button-red"
          (click)="dismissPaymentSuccess()"
          >Return to Payment Portal</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
